<template lang="pug">
	a.back-button(@click.prevent.stop="onClick" href="#")
		| < Back
</template>

<script>
export default {
	name   : 'BackButton',
	methods: {
		onClick (ev) {
			this.$router.go(-1)
		}
	}
}
</script>
